// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu-module__menu___QkFbh","left":"Menu-module__left___5B4+k","right":"Menu-module__right___CxmnE"};